import { Text } from '@fluentui/react-components';
import { format, parseISO } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../common/hooks';
import { isWindowActive } from '../../shared/functions';
import { pacificTimeZone } from '../../common/date/parse-from-pacific-timezone-date';
import { ProgramDate, ProgramDateTypes } from '../../models';

interface CurrentWindow {
  windows: ProgramDate[];
}

const CurrentWindowImpl: React.FC = () => {
  const {
    awardStore,
  } = useStores();

  const formatDateRange = (date: ProgramDate): string => {
    const startDate = format(utcToZonedTime(parseISO(date.displayStartDate), pacificTimeZone), 'MM/dd/yyyy');
    const endDate = format(utcToZonedTime(parseISO(date.displayEndDate), pacificTimeZone), 'MM/dd/yyyy');
    return `${date.displayName} (${startDate} - ${endDate})`;
  };

  const getCurrentWindows = (): CurrentWindow => {
    if (awardStore.programDates.length === 0) return { windows: [] };

    const activeWindows = awardStore.programDates.filter(date => isWindowActive(date));

    if (activeWindows.length === 0) return { windows: [] };

    const sortedWindows = activeWindows.sort((a, b) => {
      const aValue = ProgramDateTypes[b.dateTypeCode] ?? 0;
      const bValue = ProgramDateTypes[a.dateTypeCode] ?? 0;
      return aValue - bValue;
    });

    return { windows: sortedWindows };
  };

  const { windows } = getCurrentWindows();

  if (windows.length === 0) {
    return <Text>Current window: <Text weight='semibold'>None</Text></Text>;
  }

  return (
    <div className='current-windows'>
      <Text>{`Current window${windows.length > 1 ? 's' : ''}: `}</Text>
      {
        windows.length > 1 ? (
          <ul>
            {windows.map((window, index) => (
              <li key={index}>
                <Text weight='semibold'>
                  {formatDateRange(window)}
                </Text>
              </li>
            ))}
          </ul>
        ) : (
          <Text weight='semibold'>{formatDateRange(windows[0])}</Text>
        )
      }
    </div>
  );
}

export const CurrentWindow = observer(CurrentWindowImpl);
